export default function LoadingIndicator() {
  return (
    <div className="flex-1 w-[48px] animate-spin aspect-square border-[5px] border-primary-500 rounded-full border-b-transparent" />
  );
}
